






















import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import {successButtonColorClass} from '@/utlitities/color';
import {UserStore} from '@/store/user-module';

@Component({
  inheritAttrs: false,
})
export default class StTextarea extends Vue {
  @Prop() label!: string;
  @Prop() name!: string;
  @Prop() rules!: string;
  @Prop() value!: any;
  @Prop() inputClass!: string;
  @Prop() valImmediate!: boolean;
  @Prop() focus!: boolean;
  @Prop() isNative!: boolean;
  @Prop() disabled!: boolean;

  mounted() {
    if (this.focus) (this.$refs.inputfield as HTMLInputElement).focus();

    if(!this.isNative){
      (this.$refs.inputfield as any).resize();
    }
  }

  get successButtonColor(){
    return successButtonColorClass(UserStore.userSettings.successButtonColor)
  }

  focusNative(){

    ((this.$refs.inputfield as any).$el as any).focus()
  }

  @Emit('input')
  input(event: any) {
    return event.currentTarget.value;
  }
}
